import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

import { Hero } from "./home/hero";
import { TopCourse } from "./home/topCourse";
import { Layout } from "../components/layout/layout";
import { TopInstructor } from "./home/topInstructor";
import { Recruitment } from "./recruitment";

const Dashboard = () => {
	return (
		<React.Fragment>
			<Layout>
				<DashboardWrapper>
					<Box>
						<Hero />
						<TopCourse />
					</Box>

					<TopInstructor />
				</DashboardWrapper>
			</Layout>

			<Recruitment />
		</React.Fragment>
	)
}

const DashboardWrapper = styled(Box)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: theme.spacing(15),
	marginBottom: theme.spacing(6),

	[theme.breakpoints.down("lg")]: {
		gap: theme.spacing(10),
	},

	[theme.breakpoints.down("md")]: {
		gap: theme.spacing(6),
		marginBottom: theme.spacing(3),
	}
}))

export { Dashboard }